$('#mega-menu-collapse').on('shown.bs.collapse', function () {
  window.scrollTo(0,0);
});
